export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatMoney(amount: string | number): string {
  const n = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (Number.isNaN(n)) return String(amount);
  return `${n.toFixed(0)} ₽`;
}

export function subStatusLabel(status: string): string {
  switch (status) {
    case 'active':
      return 'Активна';
    case 'expired':
      return 'Истекла';
    default:
      return 'Нет подписки';
  }
}

export function subStatusClass(status: string): string {
  switch (status) {
    case 'active':
      return 'badge badge-success';
    case 'expired':
      return 'badge badge-warning';
    default:
      return 'badge badge-muted';
  }
}
